import classNames from 'classnames';
import { useState } from 'react';
import { Link } from 'react-router-dom';

import Button from 'shared/components/button/Button';
import Dash from 'shared/components/icon/Dash';
import Settings from 'shared/components/icon/Settings';
import { getText } from 'shared/utils/Text';

import ClaimControls from '../ClaimControls';
import CollaboratorList from '../CollaboratorList';
import CommentBoard from '../CommentBoard';
import styles from './index.module.scss';

const CollaborationCenter = ({
  type,
  betId,
  comments,
  claimStatus,
  remainingClaimTime,
  isLackingSubscription,
  collaborators,
  isReadOnly,
  isOwner,
  addComment,
  updateComment,
  deleteComment,
  claimBet,
  releaseBet,
  onClose,
  openShareDialog,
}) => {
  const [showCollaboratorList, setShowCollaboratorList] = useState(true);
  let claimControlsContent;
  if (isReadOnly) {
    claimControlsContent = (
      <div className={styles.readonly}>
        {getText('claim-controls-read-only-message')}
      </div>
    );
  } else if (isLackingSubscription) {
    claimControlsContent = (
      <div className={styles.readonly}>
        <div>{getText('claim-controls-no-subscription-message')}</div>
        <Link to={`/trav/${betId}/uppgradera`} className={styles.button}>
          {getText('claim-controls-no-subscription-upgrade-link')}
        </Link>
      </div>
    );
  } else {
    claimControlsContent = (
      <ClaimControls
        collaborators={collaborators}
        claimStatus={claimStatus}
        remainingClaimTime={remainingClaimTime}
        claimBet={claimBet}
        releaseBet={releaseBet}
      />
    );
  }
  return (
    <>
      <div className={styles.headerContainer}>
        <div className={styles.header}>{getText('collaborate-title')}</div>
        <Button onClick={onClose} className={styles.closeButton}>
          <Dash />
        </Button>
      </div>
      <div className={styles.viewport}>
        <div className={styles.body}>
          <div className={styles.claimControlsContainer}>
            {claimControlsContent}
          </div>

          <div className={styles.collaboratorsContainer}>
            <div
              className={classNames(styles.sectionHeader, {
                [styles.sectionHeaderLink]: isOwner,
              })}
              onClick={isOwner ? openShareDialog : undefined}
              title={
                isOwner ? getText('collaborator-list-title-tooltip') : undefined
              }
            >
              {collaborators.length} {getText('collaborator-list-title')}
              {isOwner && <Settings />}
            </div>
            <Button
              onClick={() => setShowCollaboratorList(!showCollaboratorList)}
              className={styles.sectionHeaderToggleButton}
            >
              {showCollaboratorList ? 'Dölj' : 'Visa'}
            </Button>
            {showCollaboratorList && (
              <CollaboratorList
                collaborators={collaborators}
                claimStatus={claimStatus}
                invitePath={`/invites/${
                  type === 'sport' ? 'sport' : 'trav'
                }/${betId}`}
              />
            )}
          </div>
          <div className={styles.commentsContainer}>
            <CommentBoard
              collaborators={collaborators}
              comments={comments}
              addComment={addComment}
              updateComment={updateComment}
              deleteComment={deleteComment}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CollaborationCenter;
